module.exports = __webpack_public_path__ + "img/ultra_1_02.116aa008.jpg";